<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div class="content-section">
      <div class="close-btn-container">
        <v-btn
          fab
          color="#FFF"
          small
          rounded
          elevation="0"
          @click="showModal = false"
        >
          <v-icon color="#37474f">
            mdi mdi-close
          </v-icon>
        </v-btn>
      </div>
      <h1 class="header-style">
        Create invoice
      </h1>
      <br>
      <p class="subheader-style">
        Fill the details for invoice creation
      </p>
      <v-card
        color="transparent"
        elevation="0"
      >
        <v-card-text>
          <v-form
            ref="form"
            v-model="isFormValid"
          >
            <v-expansion-panels light>
              <v-expansion-panel>
                <v-row>
                  <v-col cols="10">
                    <v-text-field
                      v-model="from"
                      label="From"
                      light
                      disabled
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-expansion-panel-header />
                  </v-col>
                </v-row>

                <v-expansion-panel-content>
                  <v-text-field
                    v-model="fromAddressLine1"
                    label="Address"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="fromAddressCity"
                    label="City"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="fromAddressState"
                    label="State"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="fromPin"
                    label="Postal Code"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="fromAddressPhoneNumber"
                    label="Phone Number"
                    dense
                    disabled
                    light
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-expansion-panels light>
              <v-expansion-panel>
                <v-row>
                  <v-col cols="10">
                    <v-text-field
                      v-model="to"
                      label="To"
                      light
                      disabled
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-expansion-panel-header />
                  </v-col>
                </v-row>

                <v-expansion-panel-content>
                  <v-text-field
                    v-model="toAddressLine1"
                    label="Address"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="toAddressCity"
                    label="City"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="toAddressState"
                    label="State"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="toPin"
                    label="Postal Code"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="toAddressPhoneNumber"
                    label="Phone Number"
                    dense
                    disabled
                    light
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-select
              v-model="job"
              light
              color="#37474F"
              :items="jobsList"
              item-text="name"
              item-value="id"
              :rules="[(v) => !!v || 'This field is required']"
              label="Job"
              background-color="transparent"
              class="small-select"
            />
            <v-row>
              <v-col cols="6">
                <v-dialog
                  ref="fromDialog"
                  v-model="invoiceDateCalendar"
                  :return-value.sync="invoiceDate"
                  width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="invoiceDate"
                      background-color="transparent"
                      label="Invoice Date"
                      light
                      :rules="[(v) => !!v || 'This field is required']"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-if="invoiceDateCalendar"
                    v-model="invoiceDate"
                    full-width
                    color="#37474F"
                    light
                    @input="$refs.fromDialog.save(invoiceDate)"
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="#37474F"
                      @click="invoiceDateCalendar = false"
                    >
                      Cancel
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="6">
                <v-dialog
                  ref="toDialog"
                  v-model="dueDateCalendar"
                  :return-value.sync="dueDate"
                  width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="dueDate"
                      background-color="transparent"
                      label="Due date"
                      light
                      v-bind="attrs"
                      :rules="[(v) => !!v || 'This field is required']"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-if="dueDateCalendar"
                    v-model="dueDate"
                    full-width
                    color="#37474F"
                    light
                    @input="$refs.toDialog.save(dueDate)"
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="#37474F"
                      @click="dueDateCalendar = false"
                    >
                      Cancel
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
            <v-btn
              class="btn-style"
              color="#64CA7F"
              elevation="0"
              @click="addItem()"
            >
              Add Item
            </v-btn>
            <br>
            <br>
            <v-simple-table light>
              <template #default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Item
                    </th>
                    <th class="text-left">
                      Unit Price
                    </th>
                    <th class="text-left">
                      Qty.
                    </th>
                    <th class="text-left">
                      Amt.
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in itemsList"
                    :key="item.name"
                  >
                    <td>{{ item.itemName }}</td>
                    <td>{{ item.unitPrice }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.amount }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-form>
          <hr>
          <br>
          <div>
            <div class="total-amt">
              <h4>Total</h4>
              <h4>$ {{ totalAmount }}</h4>
            </div>
            <div class="total-amt pt-2">
              <h4>GST (10%)</h4>
              <span>
                <h4>$ {{ taxAmount }}</h4>
                <hr class="mt-1">
              </span>
            </div>
            <div class="total-amt">
              <h3>Grand Total</h3>
              <h3>$ {{ grandTotal }}</h3>
            </div>
            <br>
          </div>
          <hr>
          <br>
          <v-btn
            class="btn-style"
            color="#64CA7F"
            elevation="0"
            @click="createInvoice()"
          >
            Create Invoice
          </v-btn>
        </v-card-text>
      </v-card>
    </div>
    <centre-spinner :loading="loading" />
    <add-invoice-items
      v-if="showAddForm"
      @add="addItemToTable"
      @closed="showAddForm = false"
    />
  </v-dialog>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import moment from 'moment';
import AddInvoiceItems from './AddInvoiceItems.vue';
import Constants from 'src/constants';

export default {
  name: 'InvoiceCreateForm',
  components: {
    'centre-spinner': spinner,
    'add-invoice-items': AddInvoiceItems,
  },
  data () {
    return {
      showModal: true,
      loading: false,
      from: null,
      job: null,
      to: null,
      abnNumber: null,
      invoiceDate: moment().format('YYYY-MM-DD'),
      invoiceDateCalendar: false,
      dueDate: null,
      dueDateCalendar: false,
      toAddressPhoneNumber: null,
      toAddressState: null,
      toAddressCity: null,
      toAddressLine1: null,
      fromAddressPhoneNumber: null,
      fromAddressState: null,
      fromAddressCity: null,
      fromAddressLine1: null,
      fromPin: null,
      toPin: null,
      showAddForm: false,
      itemsList: [],
      total: 0,
      isFormValid: false,
    };
  },
  computed: {
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    user () {
      return this.$store.getters.getUser;
    },
    jobsList () {
      return this.$store.getters['jobs/getAcceptedJobs'];
    },
    totalAmount () {
      let totalAmount = 0;
      this.itemsList.filter((item) => {
        totalAmount = totalAmount + item.amount;
      });
      return totalAmount;
    },
    taxAmount () {
      return (this.totalAmount * 10) / 100;
    },
    grandTotal () {
      return this.totalAmount + this.taxAmount;
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  async mounted () {
    this.loading = true;
    await this.fetchJobs();
    await this.loadOnMount();
    this.loading = false;
  },
  methods: {
    async fetchJobs () {
      await this.$store.dispatch('jobs/fetchAcceptedJobs', {
        externalId: this.selectedOrganization.organization.external_id,
        params: {
          params: {
            status: 'accepted',
          },
        },
      });
    },
    loadOnMount () {
      const company =
        this.selectedOrganization && this.selectedOrganization.company
          ? this.selectedOrganization.company
          : {};
      const organization =
        this.selectedOrganization && this.selectedOrganization.organization
          ? this.selectedOrganization.organization
          : {};
      this.from = company.name ? company.name : 'N/A';
      this.fromAddressLine1 =
        company.address && company.address.line1
          ? company.address.line1
          : 'N/A';
      this.fromAddressCity =
        company.address && company.address.city ? company.address.city : 'N/A';
      this.fromAddressState =
        company.address && company.address.state
          ? company.address.state
          : 'N/A';
      this.fromAddressPhoneNumber = company.phone_number
        ? company.phone_number
        : 'N/A';
      this.abnNumber = company.abn_number ? company.abn_number : 'N/A';
      this.fromPin =
        company.address && company.address.postal_code
          ? company.address.postal_code
          : 'N/A';
      this.toPin =
        organization.address && organization.address.postal_code
          ? organization.address.postal_code
          : 'N/A';
      this.to = organization.name ? organization.name : 'N/A';
      this.toAddressLine1 =
        organization.address && organization.address.line1
          ? organization.address.line1
          : 'N/A';
      this.toAddressCity =
        organization.address && organization.address.city
          ? organization.address.city
          : 'N/A';
      this.toAddressState =
        organization.address && organization.address.state
          ? organization.address.state
          : 'N/A';
      this.toAddressPhoneNumber =
        this.selectedOrganization && this.selectedOrganization.phone_number
          ? this.selectedOrganization.phone_number
          : 'N/A';
    },
    addItem () {
      this.showAddForm = true;
    },
    addItemToTable (data) {
      this.itemsList.push(data);
    },
    async createInvoice () {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please fill the required fields before proceeding',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      if (this.itemsList.length === 0) {
        this.$store.dispatch(
          'alert/onAlert',
          {
            message: 'Please add items before proceeding',
            type: Constants.ALERT_TYPE_ERROR,
          },
          { root: true },
        );
        return;
      }
      this.loading = true;
      await this.$store
        .dispatch('invoice/createInvoice', {
          params: {
            amount: this.grandTotal.toString(),
            invoice_type: 'job',
            invoice_type_id: this.job,
            to: this.selectedOrganization.organization.external_id,
            line_items: this.itemsList,
            due_date: this.dueDate,
            issue_date: this.invoiceDate,
            status: 'draft',
          },
          orgExtId: this.selectedOrganization.organization.external_id,
        })
        .then(() => {
          this.$router.push({ name: 'Generate Invoices' });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.close-btn-container {
  width: 100%;
  text-align: right;
}

.close-button {
  position: absolute;
  top: 0;
}

.header-style {
  margin-top: 0px;
}

.theme--dark.v-list {
  background-color: white !important;
}

.theme--dark >>> .v-list-item {
  color: #37474f !important;
}

.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: transparent !important;
}

.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  /* padding: 0 !important; */
  box-shadow: none !important;
}

.v-expansion-panel >>> .v-expansion-panel-header {
  padding: 0 !important;
  display: flex !important;
  align-items: start !important;
}

.v-expansion-panel-header >>> .v-expansion-panel-header__icon {
  margin-top: 12px !important;
  display: flex !important;
}

.v-item-group {
  position: unset !important;
}

.total-amt {
  display: flex;
  justify-content: space-between;
}
.v-card__text {
  padding: 16px 0px 16px 0px !important;
}
</style>
